import { render, staticRenderFns } from "./BulkActionReport.vue?vue&type=template&id=6b0f3e4d&"
import script from "./BulkActionReport.vue?vue&type=script&lang=js&"
export * from "./BulkActionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports